// Overlays: tooltips, popovers and truncated text.
import TooltipController from '../../view_components/overlays/tooltip/tooltip'
import DetectTruncationController from './controllers/detect_truncation_controller'
import FloatingUiController from './controllers/floating_ui'

export function register(application) {
  application.register('tooltip', TooltipController)
  application.register('detect-truncation', DetectTruncationController)
  application.register('floating-ui', FloatingUiController)
}
